<template>
  <div class="h-100">
    <CardWrapper
      :isLoading="preloader"
      :hasAccess="access"
      @dblclick="$router.push('/summary')"
    >
      <template #title>
        СТАТИСТИКА
        <div class="help_symbol ml-2" @click.stop="isAlertOpen = true">?</div>
      </template>
      <template #icon>
        <MonitoringIcon
          style="max-width: 18px; fill: #8AA1AC; font-size: 16px"
        />
      </template>
      <div class="px-3 py-2 ">
        <div
          class="summary-row pa-1"
          v-for="(row, index) in rows"
          :key="index"
        >
          <div class="gray summary-row-name">{{row.FieldName}}</div>
          <div class="black--text font-weight-bold summary-row-cost">{{ row.Count }}</div>
          <div class="green--text summary-row-percent font-weight-bold" v-if="parseInt(row.PrevCount) !== 0">{{row.Growth}}%
            <v-icon
              title="По отношению к аналогичному периоду прошлого года"
              medium
              :class=" (row.Growth > 0) ? 'green--text' : 'red--text'"
            >{{ (row.Growth > 0)? 'arrow_upward' : 'arrow_downward' }}</v-icon>
          </div>
          <div v-else class="summary-row-percent">
            -
            <v-icon
              title="Нет данных для сравнения"
              medium
              class="orange--text ml-1"
            >history</v-icon>
          </div>

        </div>
      </div>

      <template #permissionDenied>
        <div v-if="!access" class="text-md-center blue-grey--text">
          <i class="material-icons">warning</i>
          <br>У Вас нет прав доступа для просмотра статистики!
        </div>
      </template>
    </CardWrapper>
    <v-dialog v-model="isAlertOpen" width="660">
      <v-card>
        <div class="title modal-top mb-0 pa-3">
          Общий пассажиропоток аэропорта за год: учитываются абсолютно все прибывшие/убывшие пассажиры
          <v-icon class="modal-top-close" @click="isAlertOpen = false">close</v-icon>
        </div>
        <v-divider/>
        <v-card-text class=''>
          Статистика отображает данные по количеству рейсов, пассажиров, багаже, почте, грузов и трансферам. <br><br>
          Количество рейсов разбитое на прилет и вылет не учитывает домашние рейсы (облета). <br><br>
          В конструкторе отчетов аналогичную статистику можно получить просуммировав транзитных пассажиров, трансферов (в том числе Рм), сделав выборку рейсов "по взлету и посадке" за выбранные даты.
        </v-card-text>
        <v-divider/>
        <div class="modal-bottom pa-3">
          <v-btn color="primary" class="ma-0" @click="isAlertOpen = false">ЗАКРЫТЬ</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import store from '@/store'
import MonitoringIcon from "../ui/icons/MonitoringIcon.vue";
import CardWrapper from "../ui/CardWrapper.vue";
export default {
  components: {CardWrapper, MonitoringIcon},
  data() {
    return {
      limit: 3,
      isAlertOpen: false,
      curYear: new Date().getFullYear(),
    }
  },
  computed: {
    preloader: {
      get() {
        return store.getters['summary/getPreloader']
      },
      set(value) {
        store.commit('summary/setPreloaderState', value)
      },
    },
    summary: {
      get() {
        return JSON.parse(JSON.stringify(store.getters['summary/getSummary']))
      },
      set(data) {
        store.commit('summary/setSummaryData', { data: data.value, year: data.year })
      },
    },
    access: {
      get() {
        return store.getters['chechAccess']('summary')
      },
    },
    year: {
      get() {
        return store.getters['summary/getYear']
      },
      set(value) {
        store.commit('summary/setYear', value)
      },
    },
    label: function() {
      if (this.summary === 'undefined') return { text: 'Загрузка', color: 'primary' }
      let perSum = 0
      let label = {}
      for (let i = 0; i < this.limit; i++) {
        if (this.summary[i]) perSum += this.summary[i].Growth
      }
      label.text = perSum > 0 ? 'Рост' : 'Снижение'
      label.color = perSum > 0 ? 'green' : 'red'
      return label
    },
    rows() {
      const fields = ['Рейсы','Пассажиры', 'Багаж', 'Платный багаж', 'Груз', 'Почта']
      return fields.reduce((acc, e) => {
        if (!this.summary[this.curYear]) {
          return acc
        }
        acc.push(this.summary[this.curYear].common.find(item =>
          e === item.FieldName
        ))
        return acc
      }, [])
    }
  },
  methods: {
    update: function() {
      store.dispatch('summary/updateSummary')
    },
    getlabel: function() {},
  },
}
</script>
<style scoped>
.modal-top {
  color: #424445;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: start;
  font-size: 16px;
}
.modal-top-close {
  color: #424445 !important;
  margin-left: 1px;
  cursor: pointer;
}
.modal-bottom {
  display: flex;
  justify-content: end;
}


.summary-row {
  display: grid;
  grid-template-columns: 1fr 100px 66px;
  grid-template-rows: auto;
  gap: 0 2px;
  font-size: 12px;
  border-bottom: 1px solid #EEEEEE;


  .summary-row-name {
    color: #5F6368;
  }

  .summary-row-percent {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .summary-row-cost, .summary-row-percent {
    text-align: right;
  }

  i {
    font-size: 18px !important;
  }
}
.help_symbol {
  max-width: 20px;
  min-height: 20px;
  text-align: center;
  border: 2px solid #D9D9D9;
  border-radius: 100%;
  font-size: 10px;
  background-color: #EEEEEE;
  cursor: pointer;
}
</style>
